<template>
	<div class="omapi-tabnav">
		<div
			v-for="(tab, slug) in tabs"
			:key="slug"
			class="omapi-tabnav__item"
			:class="{ 'omapi-tabnav__item-active': isActive(slug) }"
			@click="goTo(tab.route)"
		>
			{{ tab.name }}
		</div>
	</div>
</template>

<script>
import router from '@/router';

export default {
	props: {
		current: {
			type: String,
			default() {
				return '';
			},
		},
		tabs: {
			type: Object,
			default() {
				return {};
			},
		},
	},
	methods: {
		isActive(slug) {
			return slug === this.current;
		},
		goTo(route) {
			if (!route.path) {
				return;
			}

			router.push({ name: route.path, params: route.params });
		},
	},
};
</script>
<style lang="scss">
@import '../../assets/scss/tabnav';
</style>
